import React, { createContext, useContext, useState, useCallback } from 'react';

// Comentarios anclados al margen (integración de los avances de main, ver
// .claude/plans/tech-debt): `DoctexHtml.jsx` (bajo la ruta del doc) y `CommentArea.jsx`
// (montado por separado vía `UniversalCommentModule.jsx`, desde `FilesAndMedia.jsx`/
// `CosmicClient.jsx`) no comparten ningún ancestro con estado propio —
// este contexto es el único canal entre "seleccioné texto y quiero comentarlo" y "el composer
// de comentarios sabe a qué texto está anclando el próximo envío". Estado puramente
// transitorio de UI, no se persiste a propósito (perderlo en un refresh es aceptable, el
// highlight ya insertado en el DOM del editor se pierde igual si no se llegó a enviar).
const CommentDraftContext = createContext(null);

export const CommentDraftProvider = ({ children }) => {
    // { tempId, previewText } | null — hay un highlight recién creado en el editor esperando
    // que el usuario escriba y envíe el comentario que lo va a anclar.
    const [pendingAnchor, setPendingAnchor] = useState(null);
    // { tempId, realId } | null — el composer ya envió el comentario; DoctexHtml.jsx debe
    // re-etiquetar el span del tempId con el comment_id real y persistir el doc.
    const [realizedAnchor, setRealizedAnchor] = useState(null);
    // tempId | null — el usuario canceló el draft antes de enviarlo; DoctexHtml.jsx debe quitar
    // el span (conservando su texto, sin el wrapper) en vez de re-etiquetarlo.
    const [cancelledAnchorId, setCancelledAnchorId] = useState(null);

    const clearPendingAnchor = useCallback(() => setPendingAnchor(null), []);
    const clearRealizedAnchor = useCallback(() => setRealizedAnchor(null), []);
    const clearCancelledAnchorId = useCallback(() => setCancelledAnchorId(null), []);

    return (
        <CommentDraftContext.Provider
            value={{
                pendingAnchor, setPendingAnchor, clearPendingAnchor,
                realizedAnchor, setRealizedAnchor, clearRealizedAnchor,
                cancelledAnchorId, setCancelledAnchorId, clearCancelledAnchorId,
            }}
        >
            {children}
        </CommentDraftContext.Provider>
    );
};

export const useCommentDraft = () => {
    const ctx = useContext(CommentDraftContext);
    if (!ctx) throw new Error('useCommentDraft debe usarse dentro de CommentDraftProvider');
    return ctx;
};
